import { Navigate, useLocation } from "@/lib/router-compat";
import SEO from "@/components/SEO";

interface RedirectProps {
  to: string;
}

const Redirect = ({ to }: RedirectProps) => {
  const location = useLocation();
  const target = to + location.search + location.hash;
  const current = location.pathname + location.search + location.hash;

  // Emit noindex during the brief redirect window so Google doesn't
  // treat a 200 SPA shell as a soft 404 while the client-side redirect
  // is in flight. Necessary because Lovable hosting only partially
  // honors public/_redirects (some rules fire at the edge, others
  // fall through to the SPA catch-all).
  return (
    <>
      {target !== current && <Navigate to={target} replace />}
      <SEO
        title="Redirecting..."
        description="Redirecting to the current location."
        robots="noindex, nofollow"
      />
    </>
  );
};

export default Redirect;
